import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import { TranslationService } from '../../../../services/translation.service';
import { WalletService }  from '../../../../services/wallet.services';

declare let $: any;
declare let Swal: any;

@Component({
    selector : 'contact-screen',
    templateUrl:'contact-screen-component.html'
})
export class ContactScreenComponent implements OnInit, OnDestroy{

  public admin=false;
  public contacts;
  public constructor( private _router : Router,public walletService: WalletService, public translate: TranslationService,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    this.contacts=[];
    this._companyService.getContacts(this._appData.instagramUser).orderBy("full_name", "asc").get().then(snap=>{
      snap.forEach( userSnap =>{
        let user=userSnap.data();

        if (!user.profile_picture){
          user.profile_picture="https://liveplanet.app.br/assets/landingstyle/profile.png"
        }       
        this.contacts.push(user)
      })
    })

  }
  public transferItens(contact){
    let quantity=this._appData.toTransferList.length;
    Swal.fire({
      text:'Você deseja transferir para '+contact.full_name+' os '+quantity+' itens?',
      title:'Transferência de itens',
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.dismiss=='backdrop') {}
      else if (result.dismiss=='close') {}
      else if (result.dismiss=='cancel'){}
      else{
        let sample=this._appData.toTransferList[0];
        let token=sample.tokenId;
        this.walletService.makeTokenTransfer(sample.owner,'user',contact.uid,'user',token,quantity,null,null,null,null,null).subscribe(res=>{
          if (res.status==200){     
            let signature=res.json();
            this._appData.toTransferList.forEach(it=>{
              it.owner=contact.uid
              it.lastTransaction=signature;
              this._companyService.getUserRoomItemRef(it.room.toString()).doc(it.objectId).set(it).then(c=>{
                quantity=quantity-1;
                if (quantity==0){
                  this._appData.toTransferList=null;
                }
              }

              )
            })
          }
          else{
            Swal.fire({title:'Falha',text:'Erro na transferencia'})
          }
        },err=>{
          Swal.fire({title:'Falha',text:'Erro na transferencia'})
        })

      }
    });       
  
  }
  public doSearch(event: any){
    let input=$("#searchInput").val();
    this.contacts=[];
    let upper=input.toUpperCase();
    this._companyService.getContacts(this._appData.instagramUser).where("full_name", ">=", upper).orderBy("full_name", "asc").get().then(snap=>{
      snap.forEach( userSnap =>{
        let user=userSnap.data();

        if (!user.profile_picture){
          user.profile_picture="https://liveplanet.app.br/assets/landingstyle/profile.png"
        }       
        this.contacts.push(user)
      })
    })

  }
  public openScreen(screen){
    this._appData.cellScreen=screen;
  }

  public ngOnDestroy() : any {
  }

  public openChat(contact){
    this._appData.talkTo=contact;
    this._appData.cellScreen='chat'
    setTimeout(()=>{
      $('#cellChatReload').click()
    },1000)
  }
  public openConference(contact){
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_3'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_4'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,contact,this.translate.instant('CONTACT_SCREEN_COMPONENT_21'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_22'),"newCellJitsi","",false)
        Swal.fire({
          title:this.translate.instant('CONTACT_SCREEN_COMPONENT_16'),
          message: contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_20')
        });
      }
    });       
  }
  public kick(contact){
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_5'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_6')+contact.full_name+'?',
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,{uid:contact.uid,full_name:contact.full_name},this.translate.instant('CONTACT_SCREEN_COMPONENT_23'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_24'),'kick',null,null)
      }
    })

  }
  public ban(contact){
    let admin=false;
    if (this._appData.event.admins){
      this._appData.event.admins.forEach((val)=>{
        if (val==this._appData.instagramUser.uid){
          admin=true;
          this._appData.instagramUser.vip=true;
        }
      }) 
    }
    if (admin){
      Swal.fire({
        title:this.translate.instant('CONTACT_SCREEN_COMPONENT_7'),
        text:this.translate.instant('CONTACT_SCREEN_COMPONENT_8')+contact.full_name+'',
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText:this.translate.instant('NO'),
        showCancelButton: true,
        showCloseButton: true,
        preConfirm: () => {
          this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,{uid:contact.uid,full_name:contact.full_name},this.translate.instant('CONTACT_SCREEN_COMPONENT_25'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_26'),'ban',null,null)
        }
      })  
    }
    else{
      Swal.fire({
        title:this.translate.instant('CONTACT_SCREEN_COMPONENT_7'),
        text:this.translate.instant('CONTACT_SCREEN_COMPONENT_10')
      })  

    }

  }
  public yoink(contact){
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_12'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_11')+contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_9'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,contact,'Yoink',this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_13'),'Yoink',0,null)
      }

    })

  }
  public trade(contact){
    this._appData.friendOnEvent=contact;
    $("#tradeModal").modal("show");  
    $("#tradeModalClick").click();

  }
  public goto(contact){
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_14'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_15'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,contact,this.translate.instant('CONTACT_SCREEN_COMPONENT_18'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_19'),"newCellTeleport",this._appData.room.id,false)
        Swal.fire({
          title:this.translate.instant('CONTACT_SCREEN_COMPONENT_16'),
          message: contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_17')
        });
      }
    });       
  }
  public seeProfile(contact){
    this._appData.talkTo=contact;
    this._appData.cellScreen='profile'
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/contact-screen/contact-screen-component.ts